const HomeAbout = () => {
    return (
        <div className="section bg-dark overflow-hidden">
            <div className="about-section section-padding mt-n3 mb-n1">
                <div
                    className="about-images"
                    style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/images/about-images.png)`,
                    }}
                ></div>

                <div className="container">
                    <div
                        className="row justify-content-end"
                        data-aos="fade-up"
                        data-aos-duration="1200"
                    >
                        <div className="col-lg-6">
                            <div className="about-content">
                                <h3 className="title">Soul House Harmony</h3>
                                <p className="about-text">
                                    Soul Harmony House is a holistic well-being
                                    focused company, established in April 2023,
                                    with aspirations to help people achieve
                                    harmony between body, mind, and soul. It
                                    offers a wide range of programs and services
                                    that focus on stabilizing and healing the
                                    soul by transforming and replacing negative
                                    energy with positive vibes.
                                </p>
                                <p>
                                    At Soul Harmony House, we understand that
                                    each and every individual is having their
                                    own journey, facing their own challenges,
                                    and growing on their own pace. <br /> <br />{" "}
                                    That is why we wanted to create an inclusive
                                    community that helps each and every person
                                    to access their full potential through
                                    physical, mental, and emotional well-being.
                                    We aim to help each individual to reach the
                                    level of harmony where their mind, body, and
                                    soul are in sync, whether through nutrition,
                                    exercises, spirituality, creativity, engram,
                                    coaching, or any other needed means; we are
                                    here for you.{" "}
                                </p>
                                <p>
                                    In summary, Soul Harmony House is a place
                                    where individuals can find the support and
                                    resources they need to achieve holistic
                                    wellness and personal growth. Its programs
                                    and services are designed to help
                                    individuals work on their mind, body, and
                                    soul, and create a deeper connection with
                                    themselves and the world around them.
                                </p>
                                <img
                                    className="signechar"
                                    src="./images/signechar.png"
                                    alt=""
                                />
                                <h6 className="name">Ahmed Sedky</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeAbout;
